import { NgModule } from '@angular/core';

import { CustomErrorStateMatcherDirective } from './custom-error-state-matcher.directive';
import { NgrxMatSelectViewAdapter } from './mat-select-view-adapter';
import { NgrxFormControlStateErrorsDirective } from './ngrx-form-control-state-errors.directive';

@NgModule({
    declarations: [
        CustomErrorStateMatcherDirective,
        NgrxFormControlStateErrorsDirective,
        NgrxMatSelectViewAdapter
    ],
    exports: [
        CustomErrorStateMatcherDirective,
        NgrxFormControlStateErrorsDirective,
        NgrxMatSelectViewAdapter
    ]
})
export class NgrxFormsMaterialModule {

}
